const { io } = require("socket.io-client");

let realtime = { 'on': function () { }, 'emit': function () { } };
try {
	// realtime = io(`${location.protocol}//${location.hostname}:3023/realtimeModule`);
	realtime = io(`${location.protocol}//${location.hostname}:3010/realtimeModule`);
} catch (error) {
	console.error(error);
}

module.exports = {
	realtime
}
